import type { ComponentProps } from 'react';
import styled from 'styled-components';

import { EdgeRectangleShape } from '#src/atoms/ui/EdgeRectangleShape/index.tsx';

const Root = styled.div`
  --cropped: 5px;
  width: min-content;
  overflow: hidden;
  margin-top: calc(var(--cropped, 0) * -1);

  & > * {
    transform: translateY(calc(var(--cropped, 0)));
  }
`;
const Inner = styled.div`
  padding-bottom: var(--cropped);
`;

type Props = Exclude<ComponentProps<typeof EdgeRectangleShape>, 'shape'>;

export const EdgeRectangleTrapezoid = ({ children, ...rest }: Props) => {
  return (
    <Root>
      <EdgeRectangleShape shape="trapezoid" {...rest}>
        <Inner>{children}</Inner>
      </EdgeRectangleShape>
    </Root>
  );
};
